import { styled } from '@mui/material/styles'
import { Button } from '@mui/material'
import { createWithLoadingButton } from '$common/buttons/with-loading-button'

// TODO it should be clear for color of button on hover
const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary500,
  color: theme.palette.white,
  '&:hover': {
    backgroundColor: theme.palette.primary500,
  },
  '&.Mui-disabled': {
    backgroundColor: `${theme.palette.neutral400} !important`,
    color: theme.palette.neutral000,
  },
  '& .MuiButton-endIcon': {
    margin: 0,
    '& > svg': {
      fontSize: '24px',
    },
  },
}))

export const PrimaryButton = createWithLoadingButton(StyledButton)
